module.exports = __webpack_public_path__ + "assets/pencil-white-319d75.svg";